import { fetchText } from '../fetch-helper/fetch-helper';
import { openPanel, updatePanel } from '../slideout-panel/slideout-panel';

const openCountrySelectorPanel = () => {
    console.log('Open Country / Currency Selector Panel');

    const url = `/country-selector`;
    const data = fetchText(url, null);

    data.then(async (html) => {
        updatePanel('CountrySelector', html);

        const context = document.querySelector('.currency-selector-page') as HTMLElement;
        if (context) {
            setupCountrySelectorGrouping(context);
        }
    });
};

export const initCountrySelectorSlideout = () => {
    const buttons = document.querySelectorAll<HTMLElement>('.js-open-currency-selector');
    buttons.forEach(button => {
        if (!button) return;

        button.addEventListener('click', (e) => {
            e.preventDefault();
            openPanel('CountrySelector', openCountrySelectorPanel());
        });
    });
};

export const setupCountrySelectorGrouping = (context: HTMLElement) => {
    const list = context.querySelector<HTMLElement>(".js-country-list");
    const search = context.querySelector<HTMLInputElement>(".js-country-search");
    const hiddenInput = context.querySelector<HTMLInputElement>(".js-country-input");
    const form = context.querySelector<HTMLFormElement>("form");

    if (!list || !search || !hiddenInput || !form) return;

    const countries = Array.from(
        list.querySelectorAll<HTMLElement>(".country-item")
    )
        .map(item => ({
            name: (item.dataset.name ?? item.textContent ?? "").trim(),
            code: item.dataset.code ?? ""
        }))
        .filter(c => c.name && c.code);

    const buildList = (filter: string = "") => {
        list.innerHTML = "";

        const groups: Record<string, { name: string; code: string }[]> = {};

        countries.forEach(country => {
            const lowerName = country.name.toLowerCase();
            if (filter && !lowerName.includes(filter)) return;

            const firstLetter = country.name.charAt(0).toUpperCase();
            if (!groups[firstLetter]) {
                groups[firstLetter] = [];
            }
            groups[firstLetter].push(country);
        });

        const letters = Object.keys(groups).sort();

        if (!letters.length) {
            list.innerHTML = `<div class="no-results">No countries found</div>`;
            return;
        }

        letters.forEach(letter => {
            const group = groups[letter];
            group.sort((a, b) => a.name.localeCompare(b.name));

            const groupWrapper = document.createElement("div");
            groupWrapper.className = "country-group d-flex flex-column";

            const heading = document.createElement("div");
            heading.className = "country-group__heading";
            heading.textContent = letter;
            groupWrapper.appendChild(heading);

            group.forEach(country => {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.className = "country-item";
                btn.dataset.code = country.code;
                btn.dataset.name = country.name;
                btn.textContent = country.name;

                btn.addEventListener("click", () => {
                    if (country.code === "AU") {
                        window.location.href = "https://mossmenswear.com.au/";
                        return;
                    }
                    hiddenInput.value = country.code;
                    form.submit();
                });

                groupWrapper.appendChild(btn);
            });

            list.appendChild(groupWrapper);
        });
    };

    buildList();

    search.addEventListener("input", (e) => {
        const value = (e.target as HTMLInputElement).value.trim().toLowerCase();
        buildList(value);
    });
};

export const initNavCountrySelectorPanel = () => {
    const desktopTrigger = document.querySelector<HTMLElement>('.js-open-menu-panel[data-nav-title="Country Selector"]');
    const mobileTrigger = document.querySelector<HTMLElement>('.js-mobile-trigger[data-nav-title="Country Selector"]');

    if (!desktopTrigger && !mobileTrigger) return;

    let loadedDesktop = false;
    let loadedMobile = false;

    const loadInto = (target: HTMLElement, loadedFlag: 'desktop' | 'mobile') => {
        if ((loadedFlag === 'desktop' && loadedDesktop) || (loadedFlag === 'mobile' && loadedMobile)) return;

        if (loadedFlag === 'desktop') loadedDesktop = true;
        else loadedMobile = true;

        const url = `/country-selector`;
        const data = fetchText(url, null);

        data.then((markup) => {
            target.innerHTML = markup;

            const context = (target.querySelector('.currency-selector-page') as HTMLElement) ?? target;
            setupCountrySelectorGrouping(context);
        });
    };

    if (desktopTrigger) {
        desktopTrigger.addEventListener('click', () => {
            const wrapper = desktopTrigger.closest('.nav-main-links--has-dropdown') as HTMLElement | null;
            if (!wrapper) return;
            const dropdown = wrapper.querySelector<HTMLElement>('.dropdown-menu');
            if (!dropdown) return;

            const target = dropdown.querySelector<HTMLElement>('.js-nav-country-selector');
            if (!target) return;

            loadInto(target, 'desktop');
        });
    }

    if (mobileTrigger) {
        mobileTrigger.addEventListener('click', () => {
            const wrapper = mobileTrigger.closest('.nav-main-links--has-dropdown') as HTMLElement | null;
            if (!wrapper) return;

            const dropdown = wrapper.querySelector<HTMLElement>('.dropdown-menu');
            if (!dropdown) return;

            const target = dropdown.querySelector<HTMLElement>('.js-nav-country-selector');
            if (!target) return;

            loadInto(target, 'mobile');
        });
    }
};